'use es6';

import { apiBootstrapProperties, apiSearchForProperties, apiGetPropertiesForObjectType } from 'FormsUI/api/CustomObjects';
import { getBootstrapRequestState } from 'FormsUI/selectors/customObjects';
import I18n from 'I18n';
const createAction = name => `@@customObjects/${name}`;
export const REQUEST_PROPERTIES_BOOTSTRAP = createAction('REQUEST_PROPERTIES_BOOTSTRAP');
export const REQUEST_PROPERTIES_BOOTSTRAP_FAIL = createAction('REQUEST_PROPERTIES_BOOTSTRAP_FAIL');
export const REQUEST_PROPERTIES_BOOTSTRAP_SUCCESS = createAction('REQUEST_PROPERTIES_BOOTSTRAP_SUCCESS');
export const REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID = createAction('REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID');
export const REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID_FAIL = createAction('REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID_FAIL');
export const REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID_SUCCESS = createAction('REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID_SUCCESS');
export const SEARCH_FOR_PROPERTIES = createAction('SEARCH_FOR_PROPERTIES');
export const SEARCH_FOR_PROPERTIES_FAIL = createAction('SEARCH_FOR_PROPERTIES_FAIL');
export const SEARCH_FOR_PROPERTIES_SUCCESS = createAction('SEARCH_FOR_PROPERTIES_SUCCESS');
export const CLEAR_SEARCH_PROPERTIES = createAction('CLEAR_SEARCH_PROPERTIES');
export const RECEIVE_CUSTOM_OBJECT = createAction('RECEIVE_CUSTOM_OBJECT');
const FIX_EDITOR_SUCCESS_MESSAGE = createAction('FIX_EDITOR_SUCCESS_MESSAGE');
export const REQUEST_SUBMISSION_BOOTSTRAP = createAction('REQUEST_SUBMISSION_BOOTSTRAP');
export const REQUEST_SUBMISSION_BOOTSTRAP_FAIL = createAction('REQUEST_SUBMISSION_BOOTSTRAP_FAIL');
export const REQUEST_SUBMISSION_BOOTSTRAP_SUCCESS = createAction('REQUEST_SUBMISSION_BOOTSTRAP_SUCCESS');
const requestPropertiesBootstrap = () => ({
  type: REQUEST_PROPERTIES_BOOTSTRAP
});
const requestPropertiesBootstrapFail = error => ({
  type: REQUEST_PROPERTIES_BOOTSTRAP_FAIL,
  payload: error
});
const requestPropertiesBootstrapSuccess = payload => ({
  payload,
  type: REQUEST_PROPERTIES_BOOTSTRAP_SUCCESS
});
const requestPropertiesForObjectTypeId = id => ({
  type: REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID,
  payload: id
});
const requestPropertiesForObjectTypeIdFail = error => ({
  type: REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID_FAIL,
  payload: error
});
const requestPropertiesForObjectTypeIdSuccess = payload => ({
  payload,
  type: REQUEST_PROPERTIES_FOR_OBJECT_TYPE_ID_SUCCESS
});
const searchForProperties = searchTerm => ({
  payload: searchTerm,
  type: SEARCH_FOR_PROPERTIES
});
const searchForPropertiesFail = error => ({
  payload: error,
  type: SEARCH_FOR_PROPERTIES_FAIL
});
const searchForPropertiesSuccess = payload => ({
  payload,
  type: SEARCH_FOR_PROPERTIES_SUCCESS
});
export const clearSearchProperties = () => ({
  type: CLEAR_SEARCH_PROPERTIES
});
export const receiveCustomObject = (customObjects, flattenedObjects) => ({
  type: RECEIVE_CUSTOM_OBJECT,
  payload: {
    customObjects,
    flattenedObjects
  }
});
export const fixEditorSuccess = () => ({
  type: FIX_EDITOR_SUCCESS_MESSAGE,
  meta: {
    notification: {
      message: I18n.text('editor.form.properties.propertiesFixSuccessBody'),
      titleText: I18n.text('editor.form.properties.propertiesFixSuccessHeader'),
      type: 'success'
    }
  }
});
export const getPropertiesForObjectTypeId = id => dispatch => {
  dispatch(requestPropertiesForObjectTypeId(id));
  apiGetPropertiesForObjectType(id).then(data => {
    dispatch(requestPropertiesForObjectTypeIdSuccess({
      data,
      id
    }));
  }).catch(error => {
    dispatch(requestPropertiesForObjectTypeIdFail(error));
  });
};
export const bootstrapProperties = () => (dispatch, getState) => {
  if (!getBootstrapRequestState(getState()).shouldBeRequested()) return;
  dispatch(requestPropertiesBootstrap());
  apiBootstrapProperties().then(data => {
    dispatch(requestPropertiesBootstrapSuccess(data));
    if (data.objectTypes && Array.isArray(data.objectTypes)) {
      data.objectTypes.forEach(objectType => dispatch(getPropertiesForObjectTypeId(objectType.objectTypeId)));
    }
  }).catch(error => {
    dispatch(requestPropertiesBootstrapFail(error));
  });
};
export const searchProperties = searchTerm => (dispatch, getState) => {
  const {
    customObjects: {
      searchQueries = {}
    }
  } = getState();
  dispatch(searchForProperties(searchTerm));
  if (Object.prototype.hasOwnProperty.call(searchQueries, searchTerm)) {
    return dispatch(searchForPropertiesSuccess({
      data: searchQueries[searchTerm],
      searchTerm
    }));
  }
  return apiSearchForProperties(searchTerm).then(data => {
    dispatch(searchForPropertiesSuccess({
      data,
      searchTerm
    }));
  }).catch(error => {
    dispatch(searchForPropertiesFail(error));
  });
};